import type { Option } from '@branchjs/neo-components';
import type { CompatibleRedirectType } from 'shared/types/links/Interfaces/template/shared/IBaseFields';

const REDIRECT_TYPE_MAPPER = {
  web: 'web',
  weburl: 'web',
  deepview: 'deepview',
  default: 'default',
  any: 'any',
  Web: 'web',
  WebUrl: 'web',
  Deepview: 'deepview',
  Default: 'default',
  Any: 'any',
};

const OPTIONS = {
  DEFAULT: { value: 'default', label: 'Default Redirect' },
  WEB: { value: 'web', label: 'Web URL' },
  DEEPVIEW: { value: 'deepview', label: 'Deepview' },
};

export class RedirectTypeMappingService {
  /**
   * Maps the provided redirect type to a standardized redirect type.
   *
   * @param {CompatibleRedirectType} redirectType - The redirect type to be mapped.
   * @returns {?string} The standardized redirect type (`'web'`, `'deepview'`, `'default'`, `'any'`), or `null` if not matched.
   */
  public static getMappedRedirectType = (redirectType: CompatibleRedirectType) => {
    return REDIRECT_TYPE_MAPPER[redirectType.toLowerCase()];
  };

  /**
   * Maps a redirect type to an Option for selection.
   * @param {CompatibleRedirectType} redirectType - The redirect type to be mapped.
   * @returns {Option} An object representing the mapped redirect type with a label and value.
   */
  public static mapRedirectTypeToOption = (redirectType: CompatibleRedirectType): Option => {
    const lcRedirectType = redirectType?.toLowerCase();
    switch (lcRedirectType) {
      case 'weburl':
      case 'web':
        return OPTIONS.WEB;
      case 'deepview':
        return OPTIONS.DEEPVIEW;
      case 'any':
      case 'default':
      default:
        return OPTIONS.DEFAULT;
    }
  };
}
